import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    busy: false,
    loading: false,
    refresh: false,
    initialLoad: true,
    pinpadTransactions: {
      data: [],
    },
    pinpadOverview: {},
  },
  mutations: {
    GET_PINPAD_TRANSACTIONS_START: (state) => {
      state.busy = true;
      state.loading = true;
    },
    GET_PINPAD_TRANSACTIONS_FAILED: (state, error) => {
      state.busy = false;
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_PINPAD_TRANSACTIONS_SUCCESS: (state, pinpadTransactions) => {
      state.busy = false;
      state.loading = false;
      state.refresh = false;
      state.pinpadTransactions = pinpadTransactions;
      console.log(pinpadTransactions);
    },
    GET_PINPAD_OVERVIEW_START: (state) => {
      state.loading = true;
    },
    GET_PINPAD_OVERVIEW_FAILED: (state, error) => {
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_PINPAD_OVERVIEW_SUCCESS: (state, pinpadOverview) => {
      state.loading = false;
      state.refresh = false;
      state.initialLoad = false;
      state.pinpadOverview = pinpadOverview;
      console.log(pinpadOverview);
    },
    REFRESH: (state) => {
      state.refresh = true;
    },
  },
  actions: {
    async getPinpadTransactions({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_PINPAD_TRANSACTIONS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions?type=pinpad&start=${payload.startDate}&end=${payload.endDate}&show=20&page=${payload.page}`,
          config
        );
        const data = await response.json();
        commit("GET_PINPAD_TRANSACTIONS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_PINPAD_TRANSACTIONS_FAILED", err);
      }
    },
    async getPinpadOverview({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_PINPAD_OVERVIEW_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions/overview?type=pinpad&start=${payload.startDate}&end=${payload.endDate}`,
          config
        );
        const data = await response.json();
        commit("GET_PINPAD_OVERVIEW_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_PINPAD_OVERVIEW_FAILED", err);
      }
    },
    async refresh({ commit }) {
      commit("REFRESH");
    },
  },
};
